export default "__VITE_ASSET__C$J3GNFd__"